import type { BoolMetaDataInterface } from '@nts/std/interfaces';
import { PropertyMetaData } from './property-meta-data';

export class BoolMetaData extends PropertyMetaData implements BoolMetaDataInterface {
    static TYPE = 'Bool';
    protected override _type = BoolMetaData.TYPE;
}
